import { useState, useRef, useEffect } from 'react';
import Input from '@/components/Input';
import { formatCurrency } from '../utils';

const EditableInputCell = ({ row, column, value, onChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [internalValue, setInternalValue] = useState(value ?? '');
  const cellRef = useRef(null);

  useEffect(() => {
    setInternalValue(value ?? '');
  }, [value]);

  const isEditable = column.editable !== false;
  const numericOnly = column.numericOnly || column.format === 'currency';

  const handleSave = () => {
    if (!isEditable) {
      return;
    }

    if (onChange) {
      onChange(internalValue, { row, column });
    }

    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setInternalValue(value ?? '');
      setIsEditing(false);
    }
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    if (!numericOnly) {
      setInternalValue(newValue);
      return;
    }

    if (newValue === '' || /^[0-9.]*$/.test(newValue)) {
      setInternalValue(newValue);
    }
  };

  const formatDisplayValue = () => {
    if (column.formatValue) {
      return column.formatValue(value, row, column);
    }

    if (column.format === 'currency') {
      return formatCurrency(value);
    }

    return value ?? null;
  };

  if (!isEditable) {
    const displayValue = formatDisplayValue();

    return (
      <div className={`comp-grid-table-cell value-cell read-only ${column.cellClassName || ''}`}>
        <span className="value-display">{displayValue ?? '-'}</span>
      </div>
    );
  }

  if (isEditing) {
    return (
      <div className={`comp-grid-table-cell value-cell editing ${column.cellClassName || ''}`} ref={cellRef} tabIndex={0}>
        <Input className="value-input" value={internalValue} onChange={handleInputChange} onKeyDown={handleKeyDown} onBlur={handleSave} size="sm" autoFocus />
      </div>
    );
  }

  const displayValue = formatDisplayValue();

  const handleCellKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setIsEditing(true);
    }
  };

  return (
    <div
      className={`comp-grid-table-cell value-cell editable ${column.cellClassName || ''}`}
      ref={cellRef}
      tabIndex={0}
      onClick={(e) => {
        e.stopPropagation();
        setIsEditing(true);
      }}
      onKeyDown={handleCellKeyDown}>
      <span className="value-display">{displayValue ?? '-'}</span>
    </div>
  );
};

export default EditableInputCell;
